import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "modal warning" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchDatepicker = _resolveComponent("SearchDatepicker")!
  const _component_SearchAirports = _resolveComponent("SearchAirports")!
  const _component_SearchTravellers = _resolveComponent("SearchTravellers")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.searchTravelRequest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.searchbarHeadline), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_SearchDatepicker, {
              dateFrom: _ctx.searchTravelRequest.dateFrom,
              dateTo: _ctx.searchTravelRequest.dateTo,
              flexibleDate: _ctx.searchTravelRequest.flexibleDepartureDays,
              pageTexts: _ctx.pageTexts,
              localeStrings: _ctx.localeStrings,
              onUpdateDate: _ctx.updateDate,
              onUpdateFlexibleDate: _ctx.updateFlexibleDate,
              showFlexibleDate: true
            }, null, 8, ["dateFrom", "dateTo", "flexibleDate", "pageTexts", "localeStrings", "onUpdateDate", "onUpdateFlexibleDate"]),
            _createVNode(_component_SearchAirports, {
              airports: _ctx.searchTravelRequest.airports,
              pageTexts: _ctx.pageTexts,
              onUpdateAirports: _ctx.updateAirports
            }, null, 8, ["airports", "pageTexts", "onUpdateAirports"]),
            _createVNode(_component_SearchTravellers, {
              rooms: _ctx.searchTravelRequest.rooms,
              pageTexts: _ctx.pageTexts,
              ref: "travellersDropdown"
            }, null, 8, ["rooms", "pageTexts"]),
            _createElementVNode("button", {
              class: "btn-primary search-btn",
              disabled: _ctx.searchTravelRequest.dateFrom === null ||
        _ctx.searchTravelRequest.dateTo === null,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.searchTravel && _ctx.searchTravel(...args)))
            }, _toDisplayString(_ctx.pageTexts.searchbarButtonLabel), 9, _hoisted_2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showNewSearchWarning,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showNewSearchWarning) = $event)),
      close: _ctx.closeSearchWarningModal,
      onBeforeEnter: _ctx.onModalOpen,
      onAfterLeave: _ctx.onModalClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("button", {
            class: "close-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSearchWarningModal && _ctx.closeSearchWarningModal(...args))),
            "aria-label": _ctx.pageTexts['hotelPageGeneralModalButtonClose']
          }, null, 8, _hoisted_4),
          _createElementVNode("header", null, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['searchbarConfirmNewSearchModalHeadline']), 1)
          ]),
          _createElementVNode("div", {
            class: "rte",
            innerHTML: _ctx.pageTexts['searchbarConfirmNewSearchModalText']
          }, null, 8, _hoisted_5),
          _createElementVNode("footer", null, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)))
            }, _toDisplayString(_ctx.pageTexts['searchbarConfirmNewSearchModalButtonConfirm']), 1),
            _createElementVNode("button", {
              class: "btn-secondary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeSearchWarningModal && _ctx.closeSearchWarningModal(...args)))
            }, _toDisplayString(_ctx.pageTexts['searchbarConfirmNewSearchModalButtonCancel']), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "close", "onBeforeEnter", "onAfterLeave"])
  ], 64))
}